import { createContext } from 'react';

// type WorkflowTableContextType = [workflows: any, setWorkflows: (workflows: any) => void, updateWorkflows: () => Promise<void>];
type WorkflowTableContextType = { updateWorkflows: () => Promise<void> };

export const WorkflowTableContext = createContext<WorkflowTableContextType>({ updateWorkflows: () => Promise.resolve() });
